import React, { useEffect, useRef, useState } from "react";
import useAppStore, { setTimeAgoText, setUpdateStatus } from "../../store";
import { message } from "antd";
import { useSocket } from "../../Context/SocketContext";
import { API_ENDPOINTS } from "../../API/endpoints";
import ApiService from "../../API/apiService";
import { handleApiError } from "../../utils/CommonFunctions";

let _inActive = false;

const UserStatusHandler = ({ userData }) => {
  const [isInactive, setIsInactive] = useState(false);
  const timerRef = useRef(null);
  const socket = useSocket();
  const lastActiveStatus = useAppStore((state) => state.lastActiveStatus);
  const getCurrentUserDetails = useAppStore(
    (state) => state.currentUserDetails
  );
  const Token = localStorage.getItem("authToken");

  const timeAgo = (lastActiveTime) => {
    const now = new Date();
    const past = new Date(lastActiveTime);
    const diff = Math.abs(now - past);
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);

    if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
    if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    if (days < 7) return `${days} day${days !== 1 ? "s" : ""} ago`;
    if (weeks < 4) return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
    return past.toLocaleDateString();
  };

  useEffect(() => {
    const updateTimeAgo = () => {
      setTimeAgoText(timeAgo(lastActiveStatus));
    };
    updateTimeAgo();
    const intervalId = setInterval(updateTimeAgo, 30000);
    return () => clearInterval(intervalId);
  }, [lastActiveStatus]);

  const resetTimer = () => {
    if (_inActive) {
      setIsInactive(false);
      _inActive = false;
      handlestatus("online");
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setIsInactive(true);
      _inActive = true;
      handlestatus("offline", true);
    }, 300000); // 1min
  };

  const handlestatus = async (status, isAutomatic = false) => {
    const reqBody = {
      status: status,
      user_id: userData?._id,
      is_status: true,
      isAutomatic: isAutomatic,
    };
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.changestatus,
        reqBody
      );

      if (response?.data && response?.statusCode === 200) {
        setUpdateStatus(true);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      handleApiError(error, "Error while updating status");
    }
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
      _inActive = true;
    };
  }, [socket]);

  useEffect(() => {
    const handleActivity = () => {
      if (_inActive) {
        setIsInactive(false);
        _inActive = false;
        handlestatus("online", false, false);
      }
    };

    if (isInactive) {
      const events = [
        "click",
        "mousedown",
        "pointerdown",
        "mousemove",
        "touchstart",
        "wheel",
        "keydown",
      ];
      events.forEach((event) => window.addEventListener(event, handleActivity));
      return () => {
        events.forEach((event) =>
          window.removeEventListener(event, handleActivity)
        );
      };
    }
  }, [isInactive]);

  return null;
};

export default UserStatusHandler;
